import React from "react";
import PropTypes from "prop-types";
import { ChevronDown } from "lucide-react";

function cn(...classes) {
	return classes.filter(Boolean).join(" ");
}

/**
 * Mi sono costruito questo Select leggero per imitare l'esperienza shadcn/ui
 * senza portarmi dietro Radix: e' un select nativo con icona e stati coerenti.
 */
const Select = React.forwardRef(function Select(
	{
		label,
		value = "",
		options = [],
		placeholder,
		onValueChange,
		ariaLabel,
		className,
		disabled = false,
		name,
		id,
		onChange,
		...props
	},
	ref
) {
	const handleChange = React.useCallback(
		(event) => {
			onChange?.(event);
			onValueChange?.(event.target.value);
		},
		[onChange, onValueChange]
	);

	return (
		<div className={cn("relative", className)}>
			{label ? (
				<label
					htmlFor={id}
					className="block text-base font-medium text-slate-700 mb-2 uppercase tracking-wide"
				>
					{label}
				</label>
			) : null}
			<select
				ref={ref}
				id={id}
				name={name}
				value={value ?? ""}
				onChange={handleChange}
				aria-label={ariaLabel}
				disabled={disabled}
				className="h-9 w-full appearance-none rounded-md border border-slate-300 bg-white px-3 pr-8 text-sm text-slate-800 shadow-sm transition focus:border-slate-400 focus:outline-none focus:ring-2 focus:ring-slate-500 disabled:cursor-not-allowed disabled:bg-slate-100 disabled:text-slate-500"
				{...props}
			>
				{placeholder ? (
					<option value="" disabled hidden>
						{placeholder}
					</option>
				) : null}
				{options.map(({ value: optionValue, label }) => (
					<option key={optionValue} value={optionValue}>
						{label ?? optionValue}
					</option>
				))}
			</select>
			<ChevronDown
				className="pointer-events-none absolute right-2.5 top-[42px] h-4 w-4 text-slate-500"
				aria-hidden
			/>
		</div>
	);
});

Select.displayName = "Select";

Select.propTypes = {
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
				.isRequired,
			label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		})
	),
	placeholder: PropTypes.string,
	onValueChange: PropTypes.func,
	ariaLabel: PropTypes.string,
	className: PropTypes.string,
	disabled: PropTypes.bool,
	name: PropTypes.string,
	id: PropTypes.string,
	onChange: PropTypes.func,
};

export default Select;
